import { LocationTypes } from '../locationTypes';

export const convertNormalHrsToFormatted = (hours: string) => {
  let hoursPassed: string | number = parseInt(hours);
  if (hoursPassed > 1200) {
    // Convert 24hrs time to 12 hrs time
    hoursPassed = hoursPassed - 1200;
    if (hoursPassed < 1000) {
      hoursPassed = `0${hoursPassed} PM`;
    } else {
      hoursPassed = `${hoursPassed} PM`;
    }
  } else if (hoursPassed === 1200) {
    hoursPassed = `${hoursPassed} PM`;
  } else {
    if (hoursPassed === 0) {
      hoursPassed = `12 AM`;
    } else if (hoursPassed < 60) {
      if (hoursPassed < 10) {
        hoursPassed = `000${hoursPassed} AM`;
      } else {
        hoursPassed = `00${hoursPassed} AM`;
      }
    } else if (hoursPassed < 1000) {
      hoursPassed = `0${hoursPassed} AM`;
    } else {
      hoursPassed = `${hoursPassed} AM`;
    }
  }
  hoursPassed = hoursPassed.toString();
  return `${hoursPassed[0]}${hoursPassed[1]}:${hoursPassed[2]}${hoursPassed[3]} ${hoursPassed[5]}${hoursPassed[6]}`;
};

const getHours = (hoursConfig: LocationTypes.TOpenCloseHrs): string => {
  // Check if the 'open' field is a number (in "HHMM" format).
  if (!isNaN(hoursConfig.open as any) && !isNaN(hoursConfig.close as any)) {
    const openingHrs: string | number = convertNormalHrsToFormatted(
      hoursConfig.open
    );
    const closingHrs: string | number = convertNormalHrsToFormatted(
      hoursConfig.close
    );
    return `${openingHrs} - ${closingHrs}`;
  } else {
    // If 'open' contains any non-numeric value, return it directly.
    return hoursConfig.open;
  }
};

const generateScheduleForWeekends = (
  hoursConfig: LocationTypes.TOpenCloseHrs
): string[] => {
  return [`Sat-Sun: ${getHours(hoursConfig)}`];
};

const generateScheduleForWeekdays = (
  hoursConfig: LocationTypes.TOpenCloseHrs
): string[] => {
  return [`Mon-Fri: ${getHours(hoursConfig)}`];
};

const generateScheduleForAlldays = (
  hoursConfig: LocationTypes.TOpenCloseHrs
): string[] => {
  const result = [`All Days: ${getHours(hoursConfig)}`];
  return result;
};

const generateScheduleForADayOnly = (
  day: string,
  hoursConfig: LocationTypes.TOpenCloseHrs
) => {
  return [`${day}: ${getHours(hoursConfig)}`];
};
export const convertCMSHrsToFormattedHrs = (hoursConfig: any) => {
  if (!hoursConfig) {
    return [];
  }

  let weekFormattedHrs: string[] = [];
  const hourConfigKeys = Object.keys(hoursConfig);

  for (const key of hourConfigKeys) {
    const value = hoursConfig[key];

    // If the value is an array, process each item in the array.
    if (Array.isArray(value)) {
      for (const item of value) {
        switch (key) {
          case 'allDays':
            weekFormattedHrs.push(...generateScheduleForAlldays(item));
            break;
          case 'weekdays':
            weekFormattedHrs.push(...generateScheduleForWeekdays(item));
            break;
          case 'weekends':
            weekFormattedHrs.push(...generateScheduleForWeekends(item));
            break;
          case 'saturdayOnly':
            weekFormattedHrs.push(...generateScheduleForADayOnly('Sat', item));
            break;
          case 'sundayOnly':
            weekFormattedHrs.push(...generateScheduleForADayOnly('Sun', item));
            break;
          case 'notProvided':
            weekFormattedHrs.push(`${item.open}: ${item.close}`);
            break;
          default:
            break;
        }
      }
    } else {
      // If the value is an object (not an array), process it directly.
      switch (key) {
        case 'allDays':
          weekFormattedHrs.push(...generateScheduleForAlldays(value));
          break;
        case 'weekdays':
          weekFormattedHrs.push(...generateScheduleForWeekdays(value));
          break;
        case 'weekends':
          weekFormattedHrs.push(...generateScheduleForWeekends(value));
          break;
        case 'saturdayOnly':
          weekFormattedHrs.push(...generateScheduleForADayOnly('Sat', value));
          break;
        case 'sundayOnly':
          weekFormattedHrs.push(...generateScheduleForADayOnly('Sun', value));
          break;
        default:
          break;
      }
    }
  }

  return weekFormattedHrs;
};
